import { render } from "./Pago.vue?vue&type=template&id=0b4fd1bf"
import script from "./Pago.vue?vue&type=script&lang=js"
export * from "./Pago.vue?vue&type=script&lang=js"
script.render = render

export default script